import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
export default class default_1 extends Controller {
    connect() {
        let flatpickerOptions = Object.assign({
            minDate: "today",
            monthSelectorType: "static",
            inline: false,
            altInput: false,
            allowInput: false,
            disableMobile: true,
            altFormat: "l, F j, Y",
            dateFormat: "Y-m-d",
            onChange: (selectedDates, dateStr, instance) => {
                // Trigger a change event so the time selection controller can detect it
                const event = new Event('change', { bubbles: true });
                this.element.dispatchEvent(event);
            },
            // enable: [],
            // onMonthChange(selectedDates, value, instance, data) {
            //   console.log(instance);
            // },
        }, this.optionsValue);
        flatpickr(this.element, flatpickerOptions);
        //this.element.removeAttribute("readonly");
    }
}
default_1.values = {
    options: Object,
};
